import React from "react";
import { withRouter } from 'react-router-dom'
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { Col, Row, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select'
import debounce from 'lodash/debounce';
import './dataPanelFilter.css';
import EditSimulateCategory from "../EditSimulateCategory";
import { TooltipWrapper } from "../../../../AddMethods";
class DataPanelFilter extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            containerWidth: 0,
            selectedBrand: '',
            selectedSubCategory: '',
            selectedCategory: '',
            isHangable: 'all',
            isHangableSelectFocused: false,
        };
        this.resizeObserver = null;
    }

    componentDidMount() {
        this.initializeResizeObserver();
    }
    componentWillUnmount() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }
    initializeResizeObserver = () => {
        const element = document.querySelector('.simulation-filter-section');
        if (element) {
            this.resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.target === element) {
                        setTimeout(() => {
                            const containerWidth = entry.contentRect.width;
                            this.setState({ containerWidth });
                        }, 100);
                    }
                }
            });
            this.resizeObserver.observe(element);
        }
    }



    handleSelectChange = (selectedOption, actionMeta) => {
        const selectedValue = selectedOption ? selectedOption.value : '';


        if (actionMeta.name === 'brand') {
            this.setState({ selectedBrand: selectedValue });
            this.props.onFilterChange(selectedValue, 'brand');  // Call parent handler with type
        } else if (actionMeta.name === 'subCategory') {
            this.setState({ selectedSubCategory: selectedValue });
            this.props.onFilterChange(selectedValue, 'subCategory');  // Call parent handler with type
        } else if (actionMeta.name === 'category') {
            this.setState({ selectedCategory: selectedValue });
            this.props.onFilterChange(selectedValue, 'category');  // Call parent handler with type
        }else if(actionMeta.name === 'hangable') {
            this.setState({ isHangable: selectedValue });
            this.props.onFilterChange(selectedValue, 'hangable');
        }
    };

    handleToleranceKeyDown = (e) => {
        // Allow: backspace, delete, tab, escape, enter, arrows
        if ([
            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
            'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
        ].includes(e.key)) {
            return;
        }
        // Allow Ctrl/Cmd+A/C/V/X/Z/Y
        if ((e.ctrlKey || e.metaKey) && ['a', 'c', 'v', 'x', 'z', 'y'].includes(e.key.toLowerCase())) {
            return;
        }
        // Only allow digits
        if (!/^[0-9]$/.test(e.key)) {
            e.preventDefault();
        }
    }

    handleTolerancePaste = (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^\d{1,3}$/.test(paste)) {
            e.preventDefault();
        } else {
            const num = Number(paste);
            if (num < 0 || num > 100) {
                e.preventDefault();
            }
        }
    }

    handleToleranceChange = (e) => {
        let value = e.target.value;
        // Only allow numbers between 0 and 100
        if (value === '') {
            if (this.props.onFormValueChange) {
                this.props.onFormValueChange('');
            }
            this.setState({ formValue: '' });
            return;
        }
        // Remove any non-digit characters
        value = value.replace(/[^0-9]/g, '');
        let num = Number(value);
        if (isNaN(num)) num = '';
        if (num < 0) num = 0;
        if (num > 100) num = 100;
        if (this.props.onFormValueChange) {
            this.props.onFormValueChange(num);
        }            
        this.setState({ formValue: num });
    }

      handleKeyDown = (event) => {
        if (event.key === '-' || event.key === '.' || event.key === 'e') {
            event.preventDefault();
        }
    }

     handleInput = (event) => {
        const value = event.target.value;
        if (value < 0 || !Number.isInteger(Number(value))) {
            event.target.value = Math.abs(Math.floor(value));
        }
    }


    render() {

        const { containerWidth } = this.state;
        const { combinedProducts } = this.props;
        const sectionClass = containerWidth < 350 ? 'simulation-filter-section-small' : 'simulation-filter-section';



        //Brands transformed filter 
        const transformedBrands = [{ label: this.props.t("DATA_PANEL.allBrands"), value: 'ALL' }, ...this?.props?.allBrands
            .filter(brand => brand !== undefined && brand !== null)
            .map(brand => ({ label: brand, value: brand }))];


        const transformedSubCategory = [{ label: this.props.t("DATA_PANEL.allSubcategories"), value: 'ALL' }, ...this?.props?.allSubCat
            .filter(subCat => subCat !== undefined && subCat !== null)
            .map(subCat => ({ label: subCat, value: subCat }))];


        return (
            <div className="data-panel-filter-container">
                <ul>
                    <li className='list-inline-item filter-item'>
                        <div className='form-group filter-select'>
                            {this.state.selectedSubCategory && this.state.selectedSubCategory !== 'ALL' ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-subcategory-select">
                                            {this.state.selectedSubCategory}
                                        </Tooltip>
                                    }
                                >
                                    <div>
                                        <Select
                                            name="subCategory"
                                            placeholder={this.props.t("DATA_PANEL.allSubcategories")}
                                            options={transformedSubCategory}
                                            className="filter-selec2"
                                            size="sm"
                                            classNamePrefix="searchselect-inner"
                                            maxMenuHeight={160}
                                            onChange={this.handleSelectChange}
                                            value={
                                                this.state.selectedSubCategory
                                                    ? transformedSubCategory.find(
                                                        opt => opt.value === this.state.selectedSubCategory
                                                    )
                                                    : null
                                            }
                                        />
                                    </div>
                                </OverlayTrigger>
                            ) : (
                                <TooltipWrapper text={this.props.t('DATA_PANEL.allSubcategories')} placement="top">
                                <div>
                                <Select
                                    name="subCategory"
                                    placeholder={this.props.t("DATA_PANEL.allSubcategories")}
                                    options={transformedSubCategory}
                                    className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                    maxMenuHeight={160}
                                    onChange={this.handleSelectChange}
                                    value={this.props.defTagName}
                                />
                                </div>
                                </TooltipWrapper>                             
                            )}
                        </div>
                    </li>

                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            {this.state.selectedBrand && this.state.selectedBrand !== 'ALL' ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-brand-select">
                                            {this.state.selectedBrand}
                                        </Tooltip>
                                    }
                                >
                                    <div>
                                        <Select
                                            name="brand"
                                            menuPlacement="bottom"
                                            placeholder={this.props.t("DATA_PANEL.allBrands")}
                                            options={transformedBrands}
                                            value={
                                                this.state.selectedBrand
                                                    ? transformedBrands.find(opt => opt.value === this.state.selectedBrand)
                                                    : this.props.defTagName
                                            }
                                            className="filter-selec2 filter-select3" size="sm" classNamePrefix="searchselect-inner"
                                            maxMenuHeight={160}
                                            onChange={this.handleSelectChange}
                                        />
                                    </div>
                                </OverlayTrigger>
                            ) : (
                                <Select
                                    name="brand"
                                    menuPlacement="bottom"
                                    placeholder={this.props.t("DATA_PANEL.allBrands")}
                                    options={transformedBrands}
                                    value={this.props.defTagName}
                                    className="filter-selec2 filter-select3" size="sm" classNamePrefix="searchselect-inner"
                                    maxMenuHeight={160}
                                    onChange={this.handleSelectChange}
                                />
                            )}
                        </div>
                    </li>
                    {/* <li className='list-inline-item filter-item-dash'> | </li> */}
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            {this.state.selectedCategory ? (
                                <OverlayTrigger
                                    placement="top"
                                    overlay={
                                        <Tooltip id="tooltip-category-select">
                                            {
                                                [
                                                    { value: "all_product", label: this.props.t('DATA_PANEL.allProducts') },
                                                    { value: "simulated_only", label: this.props.t('DATA_PANEL.simulatedOnly') },
                                                    { value: "not_simulated_only", label: this.props.t('DATA_PANEL.notSimulated') }
                                                ].find(opt => opt.value === this.state.selectedCategory)?.label || this.state.selectedCategory
                                            }
                                        </Tooltip>
                                    }
                                >
                                    <div>
                                        <Select
                                            name="category"
                                            menuPlacement="bottom"
                                            placeholder={this.props.t("DATA_PANEL.allProduct")}
                                            options={[
                                                { value: "all_product", label: this.props.t('DATA_PANEL.allProducts') },
                                                { value: "simulated_only", label: this.props.t('DATA_PANEL.simulatedOnly') },
                                                { value: "not_simulated_only", label: this.props.t('DATA_PANEL.notSimulated') }
                                            ]}
                                            value={
                                                [
                                                    { value: "all_product", label: this.props.t('DATA_PANEL.allProducts') },
                                                    { value: "simulated_only", label: this.props.t('DATA_PANEL.simulatedOnly') },
                                                    { value: "not_simulated_only", label: this.props.t('DATA_PANEL.notSimulated') }
                                                ].find(opt => opt.value === this.state.selectedCategory)
                                            }
                                            className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                            maxMenuHeight={160}
                                            onChange={this.handleSelectChange}
                                        />
                                    </div>
                                </OverlayTrigger>
                            ) : (
                                <Select
                                    name="category"
                                    menuPlacement="bottom"
                                    placeholder={this.props.t("DATA_PANEL.allProduct")}
                                    options={[
                                        { value: "all_product", label: this.props.t('DATA_PANEL.allProducts') },
                                        { value: "simulated_only", label: this.props.t('DATA_PANEL.simulatedOnly') },
                                        { value: "not_simulated_only", label: this.props.t('DATA_PANEL.notSimulated') }
                                    ]}
                                    value={null}
                                    className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                    maxMenuHeight={160}
                                    onChange={this.handleSelectChange}
                                />
                            )}
                        </div>
                    </li>

                    <li className='list-inline-item filter-item'>
                        {
                            !this.state.isHangableSelectFocused ? (
                                <TooltipWrapper
                                    text={
                                        this.props.isHangable === 'all' ? this.props.t('HANGABLE_NON_HANGABLE') :
                                        this.props.isHangable ? this.props.t('HANGABLE') :
                                        !this.props.isHangable ? this.props.t('NON_HANGABLE') :
                                        this.props.t('HANGABLE_NON_HANGABLE')
                                    }
                                    placement="top"
                                >
                                    <div className='form-group'>
                                        <Select
                                            name="hangable"
                                            menuPlacement="bottom"
                                            placeholder={this.props.t('HANGABLE_NON_HANGABLE')}
                                            options={[
                                                { value: 'all', label: this.props.t('HANGABLE_NON_HANGABLE') },
                                                { value: 'true', label: this.props.t('HANGABLE') },
                                                { value: 'false', label: this.props.t('NON_HANGABLE') }
                                            ]}
                                            className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                            maxMenuHeight={160}
                                            onChange={option => this.props.onHangableFilterChange(option.value)}
                                            onFocus={() => this.setState({ isHangableSelectFocused: true })}
                                            onBlur={() => this.setState({ isHangableSelectFocused: false })}
                                            value={[
                                                { value: 'all', label: this.props.t('HANGABLE_NON_HANGABLE') },
                                                { value: 'true', label: this.props.t('HANGABLE') },
                                                { value: 'false', label: this.props.t('NON_HANGABLE') }
                                            ].find(opt => String(opt.value) === String(this.props.isHangable ?? 'all'))}
                                        />
                                    </div>
                                </TooltipWrapper>
                            ) : (
                                <div className='form-group'>
                                    <Select
                                        name="hangable"
                                        menuPlacement="bottom"
                                        placeholder={this.props.t('HANGABLE_NON_HANGABLE')}
                                        options={[
                                            { value: 'all', label: this.props.t('HANGABLE_NON_HANGABLE') },
                                            { value: 'true', label: this.props.t('HANGABLE') },
                                            { value: 'false', label: this.props.t('NON_HANGABLE') }
                                        ]}
                                        className="filter-selec2" size="sm" classNamePrefix="searchselect-inner"
                                        maxMenuHeight={160}
                                        onChange={option => this.props.onHangableFilterChange(option.value)}
                                        onFocus={() => this.setState({ isHangableSelectFocused: true })}
                                        onBlur={() => this.setState({ isHangableSelectFocused: false })}
                                        value={[
                                            { value: 'all', label: this.props.t('HANGABLE_NON_HANGABLE') },
                                            { value: 'true', label: this.props.t('HANGABLE') },
                                            { value: 'false', label: this.props.t('NON_HANGABLE') }
                                        ].find(opt => String(opt.value) === String(this.props.isHangable ?? 'all'))}
                                    />
                                </div>
                            )
                        }
                    </li>

                    <li className='list-inline-item filter-item tolerance-input' style={{ marginRight: this.props.isRTL ? '5px' : '0px' }} >
                        
                        <label>{this.props.t('DATA_PANEL.tolerance')}</label>
                        <div className='form-group'>
                            <input
                                type="number"
                                placeholder={this.props.t('enterValue')}
                                onKeyDown={this.handleToleranceKeyDown}
                                onPaste={this.handleTolerancePaste}
                                value={this.props.formValue !== undefined ? this.props.formValue : this.state.formValue}
                                onChange={this.handleToleranceChange}
                                onInput={this.handleInput}
                                className="form-control"
                                min="0"
                                max="100"
                                step="1"
                            />
                        </div>
                    </li>
                </ul>
                {/* <div>
                    <li className='list-inline-item filter-item'>
                        <label>{this.props.t('Tolerance')}</label>
                    </li>
                    <li className='list-inline-item filter-item'>
                        <div className='form-group'>
                            <input
                                type="number"
                                placeholder="Enter value"
                                value={this.state.tolerance}
                                onChange={this.handleToleranceChange}
                                className="form-control"
                            />
                        </div>
                    </li>
                </div> */}
            </div>
        );
    }
}

export default withTranslation()(withRouter(connect(null)(DataPanelFilter)));